import React from 'react';

import { OrganizationAppShell, OrganizationSettings, Settings } from '~/components/layouts';
import { OrganizationBase } from '~/components/pages/Settings_Organization_Base';
import { FirebaseProvider } from '~/components/partials';

const SettingsOrganizationPage = () => {
  return (
    <FirebaseProvider>
      <OrganizationAppShell>
        <Settings>
          <OrganizationSettings>
            <OrganizationBase />
          </OrganizationSettings>
        </Settings>
      </OrganizationAppShell>
    </FirebaseProvider>
  );
};

export default SettingsOrganizationPage;
